import React, { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import KitEditor from "src/components/TextEditorKit/KitEditor";
import { USE_TEXT_EDITOR_KIT } from "src/components/TextEditorKit/editorKitConfig";
import { invokeApi } from "src/bl_libs/invokeApi";
import { s3baseUrl } from "src/config/config";
import { useContentSetting } from "src/Hooks/ContentSettingState";

function LegacyGeneralCkeditor({
  inputs,
  setInputs,
  name,
  editorHeight,
}) {
  const editorRef = useRef(null);
  const { tinymceKey } = useContentSetting();
  const log = () => {
    if (editorRef.current) {
      setInputs((prevState) => ({
        ...prevState,
        [name]: editorRef.current.getContent(),
      }));
    }
  };

  function example_image_upload_handler(blobInfo, success, failure, progress) {
    let requestObj = {
      path: "/app/update_image_on_s3/",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let _formData = new FormData();
    _formData.append("image", blobInfo.blob());
    _formData.append("width", "600");
    requestObj["postData"] = _formData;

    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        success(s3baseUrl + res.image_path);
      } else {
        failure(res.message);
      }
    });
  }

  return (
    <>
      <Editor
        apiKey={tinymceKey}
        onChange={log}
        value={inputs[name]}
        onInit={(evt, editor) => (editorRef.current = editor)}
        onEditorChange={(newValue, editor) => {
          log(newValue, editor);
        }}
        init={{
          images_upload_handler: example_image_upload_handler,
          height: editorHeight ? editorHeight : 500,
          z_index: 13000,
          menubar: true,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table code help wordcount",
          ],
          toolbar:
            "undo redo | formatselect | " +
            "bold italic backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />
    </>
  );
}

/**
 * EDITOR-KIT: shows React Editor Kit instead of TinyMCE.
 * Same props as before (inputs, setInputs, name, editorHeight, onChangeCustom).
 * Set USE_TEXT_EDITOR_KIT = false in TextEditorKit/editorKitConfig.js to get
 * the old TinyMCE editor back.
 */
export default function GeneralCkeditor(props) {
  const { inputs, setInputs, name, editorHeight, onChangeCustom } = props;
  if (!USE_TEXT_EDITOR_KIT) return <LegacyGeneralCkeditor {...props} />;
  return (
    <KitEditor
      value={inputs?.[name] || ""}
      height={editorHeight || 500}
      onChange={(html) => {
        setInputs((prevState) => ({ ...prevState, [name]: html }));
        if (onChangeCustom) onChangeCustom(html);
      }}
    />
  );
}
